import { __extends } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-field.css';

var getClassNameList = classNames.bind(styles);
var UitkFieldLabel = /** @class */ (function (_super) {
    __extends(UitkFieldLabel, _super);
    function UitkFieldLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkFieldLabel.prototype.render = function () {
        var _a = this.props, id = _a.id, label = _a.label, className = _a.className;
        var cssClasses = getClassNameList('uitk-field-label', className);
        return (React.createElement("label", { htmlFor: id, className: cssClasses }, label));
    };
    UitkFieldLabel.displayName = 'UitkFieldLabel';
    return UitkFieldLabel;
}(React.Component));

export { UitkFieldLabel };
